import React from "react";
import "./css/backtotop.scss";
import { useLanguage } from "../../context/LanguageContext";

const BackToTop = () => {
  const { translations, toggleLanguage } = useLanguage();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Плавная прокрутка
    });
  };

  return (
    <div className="btn">
      <button className="back-to-top" onClick={scrollToTop}>
      {translations.backToTop}
      </button>
    </div>
  );
};

export default BackToTop;
